import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import MainLayout from './layouts/MainLayout';
import Login from './pages/Login';
import Dashboard from './pages/Dashboard';
import XmlManager from './pages/XmlManager';
import Settings from './pages/Settings';
import UserManagement from './pages/UserManagement';
import MasterDataManagement from './pages/MasterDataManagement';
import SystemSettings from './pages/SystemSettings'; 

// 1. IMPORT COMPONENT QUẢN LÝ CƠ SỞ KCB Ở ĐÂY
import Facilities from './pages/FacilitiesManagement'; 

// Component bảo vệ: Nếu chưa có Token thì bắt quay lại trang Login
const ProtectedRoute = ({ children }) => {
  const token = localStorage.getItem('admin_token');
  if (!token) {
    return <Navigate to="/login" replace />;
  }
  return children;
};

function App() {
  return (
    <BrowserRouter>
      <Routes>
        {/* Route công khai: Đăng nhập */}
        <Route path="/login" element={<Login />} />

        {/* Các Routes được bảo vệ: Nằm trong khung giao diện MainLayout */}
        <Route 
          path="/" 
          element={
            <ProtectedRoute>
              <MainLayout />
            </ProtectedRoute>
          }
        >
          {/* Chuyển hướng mặc định khi vào trang chủ */}
          <Route index element={<Navigate to="/dashboard" replace />} />
          
          <Route path="dashboard" element={<Dashboard />} />
          <Route path="xml" element={<XmlManager />} />

          {/* NHÓM ROUTE CÀI ĐẶT (SETTINGS) */}
          <Route path="settings">
            {/* Đây là trang "màn hình chờ điện thoại" (mặc định của settings) */}
            <Route index element={<Settings />} />
            
            {/* Đây là trang Quản lý User: /settings/users */}
            <Route path="users" element={<UserManagement />} />
            <Route path="categories" element={<MasterDataManagement />} />
            <Route path="system" element={<SystemSettings />} />
            
            {/* 2. KHAI BÁO ROUTE CHO TRANG QUẢN LÝ CƠ SỞ KCB Ở ĐÂY */}
            <Route path="facilities" element={<Facilities />} />
            
          </Route>
        </Route>

        {/* Bắt lỗi đường dẫn không tồn tại (404) -> Quay về Dashboard */}
        <Route path="*" element={<Navigate to="/dashboard" replace />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;